export default {
  Request: 1, // Giấy đề nghị xuất kho
  Order: 2,   // Lệnh xuất kho
};
